import Logger from './logger';
import config from '../../../../config/client';

export { LoggingEvents } from './loggingEvents';

const logger = new Logger(config);

export default logger;
